import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useOrgStore } from "@/stores";
import { Building2 } from "lucide-react";
import React from "react";

export function OrgSwitcher() {
  const selectedOrgId = useOrgStore.use.selectedOrgId();
  const orgs = useOrgStore.use.orgs();
  const setSelectedOrg = useOrgStore.use.setSelectedOrg();
  const fetchUserOrgs = useOrgStore.use.fetchUserOrgs();

  React.useEffect(() => {
    fetchUserOrgs();
  }, [fetchUserOrgs]);

  if (orgs.length <= 1) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1">
      <Building2 className="h-4 w-4 text-muted-foreground" />
      <Select value={selectedOrgId || undefined} onValueChange={setSelectedOrg}>
        <SelectTrigger className="h-8 w-[180px]">
          <SelectValue placeholder="Select organization..." />
        </SelectTrigger>
        <SelectContent>
          {[...orgs]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((org) => (
              <SelectItem key={org.id} value={org.id}>
                {org.name}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  );
}
